import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {getBrandUrl} from '@/_application/core/utils/common';
import {useHighlightBrands} from '@/framework/highlight-brands';
import {DEFAULT_MAX_ITEMS_PER_ROW_SWIPER} from '@/lib/constants';

export const SmallBrandSwiperHome = () => {
    const {highlightBrands} = useHighlightBrands();
    const slicedBrands = highlightBrands.slice(0, DEFAULT_MAX_ITEMS_PER_ROW_SWIPER);

    return (
        <Swiper slidesPerView={4.5} spaceBetween={20} loop>
            {slicedBrands.map(brand => {
                if (!brand?.img || !brand?.url) return <></>;

                return (
                    <SwiperSlide key={brand.label} className={`h-[56px]!`}>
                        <Link href={getBrandUrl(brand.url)} className="flex h-full w-full items-center justify-center">
                            <Image src={brand.img} alt={brand.label ?? 'Brand Image'} width={56} height={56} />
                        </Link>
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
};
